import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Dynamic_FilterForm from "./Dynamic_FilterForm";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";
import { Accordion, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
const KpiReportTable = ({
  data,
  selectedResource,
  selectAllChecked,
  columns,
  theadType,
  isSrNoRequired,
  isApiStatus,
  currentMonth,
  previousMonth,
  isRequiredStatus,
  defaultColumns,
  handleBtn,
  // itemsPerPage,
  searchTerm,
  ReadOnlyValues,

  setSearchTerm,
  handleIconClick,
  handleModalColumn,
  handleColumnSelect,
  icons,
  isActionRequired,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleGetData,
  handleAddNew,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {
  console.log("inside Tabel", isApiStatus);
  const [visibleColumns, setVisibleColumns] = useState(
    Object.keys(columns).reduce((acc, key) => {
      acc[key] = columns[key].visible; // Set initial visibility based on the 'visible' key
      return acc;
    }, {})
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [columnName]: !prevState[columnName], // Toggle visibility
    }));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  console.log("data------>", data);

  const sortedData = useMemo(() => {
    if (!Array.isArray(data) || !sortConfig) return data || [];

    const { key, direction } = sortConfig;

    return [...data].sort((a, b) => {
      const valA = a[key] ? String(a[key]) : "";
      const valB = b[key] ? String(b[key]) : "";

      const partsA = valA.match(/(\D+|\d+)/g) || [];
      const partsB = valB.match(/(\D+|\d+)/g) || [];

      for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
        const partA = partsA[i] || "";
        const partB = partsB[i] || "";

        const isNumericA = !isNaN(partA);
        const isNumericB = !isNaN(partB);

        if (isNumericA && isNumericB) {
          const numA = Number(partA);
          const numB = Number(partB);
          if (numA !== numB)
            return direction === "ascending" ? numA - numB : numB - numA;
        } else if (isNumericA || isNumericB) {
          return isNumericA ? -1 : 1;
        } else {
          const comparison = partA.localeCompare(partB);
          if (comparison !== 0)
            return direction === "ascending" ? comparison : -comparison;
        }
      }

      return 0;
    });
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  console.log("filteredData", filteredData);

  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const currentData = paginatedData.reduce((acc, item) => {
    // If this employee doesn't exist in accumulator, create an array for them
    if (!acc[item.EmployeeName]) {
      acc[item.EmployeeName] = []; // Initialize as array, not object
    }

    // Push the current item into the employee's array
    acc[item.EmployeeName].push(item);

    return acc;
  }, {});

  console.log("currentData", Object.entries(currentData).map(([employeeName, employeeItems], empIndex) => (employeeItems)));

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

  //old code for date fromat
  // const formatDate = (date) => {
  //   if (!date) return ""; // Handle null or undefined dates

  //   // Check if the date is already in DD-MM-YYYY format
  //   const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  //   if (dateRegex.test(date)) {
  //     return date;
  //   }

  //   return moment(date).format("DD-MMM-YYYY");
  // };

  //new updateed code for date fromat
  const formatDate = (date) => {
    if (!date) return "-"; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
        "DD-MMM-YYYY",
        "DD-MM-YY",
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const [dropDownValue, setDropdownValue] = useState({});

  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);

  // Calculate total pages based on the current `selectedRecordsPerPage`
  const totalPages = Math.ceil(filteredData.length / selectedRecordsPerPage);

  // Data to display for the current page
  const currentPageData = filteredData.slice(
    (currentPage - 1) * selectedRecordsPerPage,
    currentPage * selectedRecordsPerPage
  );
  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };
  const getHeaders = (filterValue) => {
    switch (filterValue) {
      case 1:
        return [
          { key: "EmployeeName", text: "Employee Name" },
          { key: "ClientName", text: "Client" },
          { key: "ProjectName", text: "Project" },
          { key: "InvoiceFromDate", text: "From" },
          { key: "InvoiceToDate", text: "To" },
          { key: "GrossSalary", text: "Gross Sal." },
          { key: "BillingRate", text: "Invoice Amount" },
          { key: "MonthlyIncentive", text: "Inc" },
          { key: "Misc", text: "Misc." },
          { key: "TotalCost", text: "Total Cost" }
        ];
      case 2:
        return [
          { key: "EmployeeName", text: "Employee Name" },
          { key: "ClientName", text: "Client" },
          { key: "ProjectName", text: "Project" },
          { key: "InvoiceFromDate", text: "From" },
          { key: "InvoiceToDate", text: "To" },
          { key: "InvoiceDate", text: "Invoice Date" },
          { key: "GrossSalary", text: "Gross Sal." },
          { key: "BillingRate", text: "Invoice Amount" },
          { key: "MonthlyIncentive", text: "Inc" },
          { key: "Misc", text: "Misc." },
          { key: "TotalCost", text: "Total Cost" }
        ];
      case 3:
        return [
          { key: "EmployeeName", text: "Employee Name" },
          { key: "ClientName", text: "Client" },
          { key: "ProjectName", text: "Project" },
          { key: "InvoiceFromDate", text: "From" },
          { key: "InvoiceToDate", text: "To" },
          { key: "Projbill", text: "Proj. Inv Amt" },
          { key: "actlbill", text: "Act. Inv Amt" },
          { key: "diff", text: "Diff." }
        ];
      default:
        return [];
    }
  };

  const formatCellValue = (key, value) => {
    if (value === null || value === undefined) return "";

    // Handle HTML content
    if (typeof value === "string" && value.includes("<span>")) {
      return <div dangerouslySetInnerHTML={{ __html: value }} />;
    }

    // Format numbers with commas
    if (key === "BillingRate" || key === "GrossSalary" || key === "TotalCost" ||
      key === "Projbill" || key === "actlbill" || key === "diff") {
      const num = parseFloat(value.toString().replace(/,/g, ''));
      if (!isNaN(num)) {
        return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }

    return value;
  };

  // Usage:
  const headers = getHeaders(theadType);
  console.log(headers);



  const [activeEmpKeys, setActiveEmpKeys] = useState([]);



  const handleClientToggle = (empKey) => {
    setActiveEmpKeys(prevKeys =>
      prevKeys.includes(empKey)
        ? prevKeys.filter(key => key !== empKey) // Close if already open
        : [...prevKeys, empKey] // Open if closed
    );
  };

  return (
    <div className="container-fluid ">
      <div className="d-flex justify-content-between">
    <div className="d-flex">
          <div className="me-1">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div>
                <Dynamic_FilterForm
                  formData={formDatas || []}
                  handleChange={handleChange}
                  // handleReset={handleReset}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
          <div style={{
  display: 'flex',
  gap: '16px',
  marginLeft: '8px'
}}>
  {ReadOnlyValues?.map((stat, index) => (
    <div 
      key={index}
      style={{
        backgroundColor: '#f8f9fa',
        padding: '4px 8px',
        borderRadius: '4px',
        height: "35px",
        border: '1px solid #dee2e6'
      }}
    >
      <span style={{ fontWeight: '600' }}>{stat.label}: </span>
      <span>
        {typeof stat.value === 'number' && stat.label.toLowerCase().includes('amount')
          ? stat.value.toLocaleString('en-IN', {
              style: 'currency',
              currency: 'INR',
              minimumFractionDigits: 2
            })
          : stat.value}
      </span>
    </div>
  ))}
</div>
        </div>

        <div className="d-flex justify-content-end">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
          >
            <div className="me-1">
              <ExportToExcel
                data={filteredData}
                filename={`${ExcelName}.csv`}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
          >
            <div className="btn-group me-2">
              <button
                type="button"
                className="dropdown-toggle skill-button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="excel-btn"
              >
                <i className="bi bi-list"></i>
              </button>
              <ul className="dropdown-menu p-2">
                <div className="row">
                  <Form.Group>
                    {Object.keys(columns).map((columnName) => (
                      <Form.Check
                        key={columnName}
                        type="checkbox"
                        id={`checkbox-${columnName}`}
                        label={columns[columnName].text} // Display the column name using 'text' key
                        checked={visibleColumns[columnName] || false} // Use 'visible' key to control the checked state
                        onChange={() => toggleColumn(columnName)} // Toggle visibility on change
                      />
                    ))}
                  </Form.Group>
                </div>
              </ul>
            </div>
          </OverlayTrigger>
          {isAddNewBtnRequired && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
            >
              <button id="Add-btn" onClick={handleAddNew}>
                <i className="fa fa-plus"></i> Add
              </button>
            </OverlayTrigger>
          )}
        </div>
      </div>
      <div className="row">
        <span>
          <span>*</span> For work done in the month of{" "}
          <strong>{previousMonth}</strong> taken on{" "}
          <strong>{currentMonth}</strong>.
        </span>
        {/* <span id="actual" style="padding-left: 15px;font-size:12px">
          <span style="font-size:15px">*</span> Invoice made in the month of{" "}
          <strong id="current1"></strong> for work done in{" "}
          <strong id="minus1"></strong> month.
        </span> */}
      </div>
      <div className=" ">
        <div className="table-responsive  mb-2">

          <Table striped bordered hover rounded>
            <thead>
              <tr id="thcolor" className="text-center">
                {headers.map((header, index) => (
                  <th style={{ width: "100px" }} key={index}>{header.text}</th>
                ))}
              </tr>
            </thead>
            {isApiStatus === 200 ? (
              Object.keys(currentData).length > 0 ? (
                <tbody>
                  {Object.entries(currentData).map(([employeeName, employeeItems], empIndex) => (
                    <tr key={empIndex}>
                      <td colSpan={headers.length} className="px-0" style={{ padding: "0px !important" }}>
                        <Accordion
                          activeKey={activeEmpKeys}
                          onSelect={() => handleClientToggle(empIndex.toString())}
                        >
                          <Accordion.Item eventKey={empIndex.toString()}>
                            <Accordion.Header className="">
                              <div
                                style={{ color: "2e2e47" }}
                                className="flex-grow-1 fw-bold d-flex me-2 justify-content-between text-dark"
                                dangerouslySetInnerHTML={{
                                  __html: employeeItems[0]?.EmpName || employeeName
                                }}
                              />
                              <span className="me-2 accordion_icon">
                                <FontAwesomeIcon
                                  icon={
                                    activeEmpKeys.includes(empIndex.toString())
                                      ? faMinus
                                      : faPlus
                                  }
                                />
                              </span>
                            </Accordion.Header>
                            <Accordion.Body className="no-padding">
                              <Table striped bordered hover size="sm">
                                <tbody>
                                  {employeeItems.map((item, itemIndex) => (
                                    <tr key={itemIndex}>
                                      {headers.map((header) => (
                                        <td style={{ width: "100px" }} key={header.key} className="text-center">
                                          {formatCellValue(header.key, item[header.key])}
                                        </td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan={headers.length} className="text-center">
                      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100px' }}>
                        No Data Found
                      </div>
                    </td>
                  </tr>
                </tbody>

              )
            ) : isApiStatus === undefined ?(
              <tbody>
                <tr>
                  <td colSpan={headers.length} className="text-center">
                    <div className="d-flex justify-content-center align-items-center">
                      <FaSpinner className="spinner" />
                    </div>
                  </td>
                </tr>
              </tbody>
            ):isApiStatus === '' ?(
              <tbody>
                <tr>
                  <td colSpan={headers.length} className="text-center">
                    <div className="d-flex justify-content-center align-items-center" >
                     No Data Found
                    </div>
                  </td>
                </tr>
              </tbody>
            ):null}
          </Table>
        </div>
        {/* {filteredData.length > itemsPerPage && ( */}
        <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                filteredData.length
              )}{" "}
              of {filteredData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={selectedRecordsPerPage}
              totalItems={filteredData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default KpiReportTable;
